webpackJsonp([1],{

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.runtime.esm.js
var vue_runtime_esm = __webpack_require__("/5sW");

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/typeof.js
var helpers_typeof = __webpack_require__("pFYg");
var typeof_default = /*#__PURE__*/__webpack_require__.n(helpers_typeof);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/json/stringify.js
var stringify = __webpack_require__("mvHQ");
var stringify_default = /*#__PURE__*/__webpack_require__.n(stringify);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/assign.js
var object_assign = __webpack_require__("woOf");
var assign_default = /*#__PURE__*/__webpack_require__.n(object_assign);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/keys.js
var keys = __webpack_require__("fZjL");
var keys_default = /*#__PURE__*/__webpack_require__.n(keys);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/elements/select.vue
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var elements_select = ({
  props: ['value', 'field', 'currentLanguage', 'disabledStatus']
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-af85943e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/select.vue
var select_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('label',{attrs:{"for":_vm.field.id}},[_vm._v(_vm._s(_vm.field.label[_vm.currentLanguage])+" "),(_vm.field.required)?_c('span',{staticClass:"required"},[_vm._v("*")]):_vm._e()]),_vm._v(" "),_c('label',{staticClass:"select",attrs:{"for":_vm.field.id}},[_c('select',{attrs:{"name":_vm.field.name,"id":_vm.field.id,"disabled":_vm.disabledStatus(_vm.field.disabled),"readonly":_vm.field.readonly,"multiple":_vm.field.multi,"required":_vm.field.required},domProps:{"value":_vm.value},on:{"input":function($event){_vm.$emit('input', $event.target.value);_vm.$emit('change', '')}}},[(!_vm.value)?_vm._t("default"):_vm._e(),_vm._v(" "),_vm._l((_vm.field.options),function(option){return _c('option',{key:option.value,domProps:{"value":option.value}},[_vm._v(_vm._s(option.label[_vm.currentLanguage]))])})],2)]),_vm._v(" "),(_vm.field.description[_vm.currentLanguage])?_c('p',{staticClass:"small"},[_vm._v(_vm._s(_vm.field.description[_vm.currentLanguage]))]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: select_render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_elements_select = (esExports);
// CONCATENATED MODULE: ./src/components/elements/select.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  elements_select,
  components_elements_select,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_elements_select = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/elements/radio.vue
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var elements_radio = ({
  props: ['value', 'field', 'currentLanguage', 'disabledStatus']
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-699d09c6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/radio.vue
var radio_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('label',{attrs:{"for":_vm.field.id}},[_vm._v(_vm._s(_vm.field.label[_vm.currentLanguage])+" "),(_vm.field.required)?_c('span',{staticClass:"required"},[_vm._v("*")]):_vm._e()]),_vm._v(" "),_vm._l((_vm.field.options),function(option,index){return _c('label',{key:index,staticClass:"control radio",attrs:{"for":'id_' + _vm.field.id + '_i_' + index}},[_c('input',{attrs:{"name":_vm.field.name + index,"type":"radio","id":'id_' + _vm.field.id + '_i_' + index,"readonly":_vm.field.readonly,"disabled":_vm.disabledStatus(_vm.field.disabled)},domProps:{"checked":_vm.value === option.value,"value":option.value},on:{"change":function($event){_vm.$emit('input', $event.target.value);_vm.$emit('change', '')}}}),_vm._v(" "),_c('span',{staticClass:"control-indicator"}),_vm._v(" "),_c('span',{staticClass:"control-label"},[_vm._v(_vm._s(option.label[_vm.currentLanguage]))])])}),_vm._v(" "),(_vm.field.description[_vm.currentLanguage])?_c('p',{staticClass:"small"},[_vm._v(_vm._s(_vm.field.description[_vm.currentLanguage]))]):_vm._e()],2)}
var radio_staticRenderFns = []
var radio_esExports = { render: radio_render, staticRenderFns: radio_staticRenderFns }
/* harmony default export */ var components_elements_radio = (radio_esExports);
// CONCATENATED MODULE: ./src/components/elements/radio.vue
var radio_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var radio___vue_template_functional__ = false
/* styles */
var radio___vue_styles__ = null
/* scopeId */
var radio___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var radio___vue_module_identifier__ = null
var radio_Component = radio_normalizeComponent(
  elements_radio,
  components_elements_radio,
  radio___vue_template_functional__,
  radio___vue_styles__,
  radio___vue_scopeId__,
  radio___vue_module_identifier__
)

/* harmony default export */ var src_components_elements_radio = (radio_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/elements/checkbox.vue
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var elements_checkbox = ({
  props: ['value', 'field', 'currentLanguage', 'disabledStatus', 'fieldIndex', 'multiCheck']
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7b42b61b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/checkbox.vue
var checkbox_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('label',{attrs:{"for":_vm.field.id}},[_vm._v(_vm._s(_vm.field.label[_vm.currentLanguage])+" "),(_vm.field.required)?_c('span',{staticClass:"required"},[_vm._v("*")]):_vm._e()]),_vm._v(" "),_vm._l((_vm.field.options),function(option,index){return _c('label',{key:index,staticClass:"control checkbox",attrs:{"for":'id_' + _vm.field.id + '_i_' + index}},[(!_vm.field.multi)?_c('input',{attrs:{"name":_vm.field.name + index,"type":"checkbox","id":'id_' + _vm.field.id + '_i_' + index,"readonly":_vm.field.readonly,"disabled":_vm.disabledStatus(_vm.field.disabled),"required":_vm.field.required},domProps:{"checked":_vm.value === option.value,"value":option.value},on:{"change":function($event){_vm.$emit('input', $event.target.value);_vm.$emit('change', '')}}}):_vm._e(),_vm._v(" "),(_vm.field.multi)?_c('input',{attrs:{"name":_vm.field.name + index,"type":"checkbox","id":'id_' + _vm.field.id + '_i_' + index,"readonly":_vm.field.readonly,"disabled":_vm.disabledStatus(_vm.field.disabled),"required":_vm.field.required},domProps:{"checked":_vm.value.indexOf(option.value) > -1,"value":option.value},on:{"change":function($event){_vm.multiCheck($event.target.value, _vm.fieldIndex);_vm.$emit('change', '')}}}):_vm._e(),_vm._v(" "),_c('span',{staticClass:"control-indicator"}),_vm._v(" "),_c('span',{staticClass:"control-label"},[_vm._v(_vm._s(option.label[_vm.currentLanguage]))])])}),_vm._v(" "),(_vm.field.description[_vm.currentLanguage])?_c('p',{staticClass:"small"},[_vm._v(_vm._s(_vm.field.description[_vm.currentLanguage]))]):_vm._e()],2)}
var checkbox_staticRenderFns = []
var checkbox_esExports = { render: checkbox_render, staticRenderFns: checkbox_staticRenderFns }
/* harmony default export */ var components_elements_checkbox = (checkbox_esExports);
// CONCATENATED MODULE: ./src/components/elements/checkbox.vue
var checkbox_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var checkbox___vue_template_functional__ = false
/* styles */
var checkbox___vue_styles__ = null
/* scopeId */
var checkbox___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var checkbox___vue_module_identifier__ = null
var checkbox_Component = checkbox_normalizeComponent(
  elements_checkbox,
  components_elements_checkbox,
  checkbox___vue_template_functional__,
  checkbox___vue_styles__,
  checkbox___vue_scopeId__,
  checkbox___vue_module_identifier__
)

/* harmony default export */ var src_components_elements_checkbox = (checkbox_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/elements/optin.vue
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var elements_optin = ({
  props: ['value', 'field', 'currentLanguage', 'disabledStatus']
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-15e1f968","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/optin.vue
var optin_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"optin-field"},[_c('label',{attrs:{"for":_vm.field.id}},[_vm._v(_vm._s(_vm.field.label[_vm.currentLanguage])+" "),(_vm.field.required)?_c('span',{staticClass:"required"},[_vm._v("*")]):_vm._e()]),_vm._v(" "),_c('label',{staticClass:"control checkbox",attrs:{"for":_vm.field.id}},[_c('input',{attrs:{"name":_vm.field.name,"type":"checkbox","id":_vm.field.id,"readonly":_vm.field.readonly,"disabled":_vm.disabledStatus(_vm.field.disabled),"multiple":_vm.field.multi,"required":_vm.field.required},on:{"change":function($event){_vm.$emit('input', $event.target.checked)}}}),_vm._v(" "),_c('span',{staticClass:"control-indicator"})]),_vm._v(" "),_c('span',{staticClass:"control-label",domProps:{"innerHTML":_vm._s(_vm.field.description[_vm.currentLanguage])}})])}
var optin_staticRenderFns = []
var optin_esExports = { render: optin_render, staticRenderFns: optin_staticRenderFns }
/* harmony default export */ var components_elements_optin = (optin_esExports);
// CONCATENATED MODULE: ./src/components/elements/optin.vue
var optin_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var optin___vue_template_functional__ = false
/* styles */
var optin___vue_styles__ = null
/* scopeId */
var optin___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var optin___vue_module_identifier__ = null
var optin_Component = optin_normalizeComponent(
  elements_optin,
  components_elements_optin,
  optin___vue_template_functional__,
  optin___vue_styles__,
  optin___vue_scopeId__,
  optin___vue_module_identifier__
)

/* harmony default export */ var src_components_elements_optin = (optin_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/elements/input.vue
//
//
//
//
//
//
//
//

/* harmony default export */ var input = ({
  props: ['value', 'field', 'currentLanguage', 'disabledStatus']
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7f9b1725","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/input.vue
var input_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('label',{attrs:{"for":_vm.field.id}},[_vm._v(_vm._s(_vm.field.label[_vm.currentLanguage])+" "),(_vm.field.required)?_c('span',{staticClass:"required"},[_vm._v("*")]):_vm._e()]),_vm._v(" "),_c('input',{attrs:{"name":_vm.field.name,"type":_vm.field.subtype,"id":_vm.field.id,"readonly":_vm.field.readonly,"disabled":_vm.disabledStatus(_vm.field.disabled),"multiple":_vm.field.multi,"required":_vm.field.required},domProps:{"value":_vm.value},on:{"change":function($event){_vm.$emit('input', $event.target.value);_vm.$emit('change', '')}}}),_vm._v(" "),(_vm.field.description[_vm.currentLanguage])?_c('p',{staticClass:"small",domProps:{"innerHTML":_vm._s(_vm.field.description[_vm.currentLanguage])}}):_vm._e()])}
var input_staticRenderFns = []
var input_esExports = { render: input_render, staticRenderFns: input_staticRenderFns }
/* harmony default export */ var elements_input = (input_esExports);
// CONCATENATED MODULE: ./src/components/elements/input.vue
var input_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var input___vue_template_functional__ = false
/* styles */
var input___vue_styles__ = null
/* scopeId */
var input___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var input___vue_module_identifier__ = null
var input_Component = input_normalizeComponent(
  input,
  elements_input,
  input___vue_template_functional__,
  input___vue_styles__,
  input___vue_scopeId__,
  input___vue_module_identifier__
)

/* harmony default export */ var components_elements_input = (input_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/elements/textarea.vue
//
//
//
//
//
//
//
//

/* harmony default export */ var elements_textarea = ({
  props: ['value', 'field', 'currentLanguage', 'disabledStatus']
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-655a9bec","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/textarea.vue
var textarea_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('label',{attrs:{"for":_vm.field.id}},[_vm._v(_vm._s(_vm.field.label[_vm.currentLanguage])+" "),(_vm.field.required)?_c('span',{staticClass:"required"},[_vm._v("*")]):_vm._e()]),_vm._v(" "),_c('textarea',{attrs:{"name":_vm.field.name,"id":_vm.field.id,"readonly":_vm.field.readonly,"disabled":_vm.disabledStatus(_vm.field.disabled),"multiple":_vm.field.multi,"required":_vm.field.required},domProps:{"value":_vm.value},on:{"change":function($event){_vm.$emit('input', $event.target.value);_vm.$emit('change', '')}}}),_vm._v(" "),(_vm.field.description[_vm.currentLanguage])?_c('p',{staticClass:"small"},[_vm._v(_vm._s(_vm.field.description[_vm.currentLanguage]))]):_vm._e()])}
var textarea_staticRenderFns = []
var textarea_esExports = { render: textarea_render, staticRenderFns: textarea_staticRenderFns }
/* harmony default export */ var components_elements_textarea = (textarea_esExports);
// CONCATENATED MODULE: ./src/components/elements/textarea.vue
var textarea_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var textarea___vue_template_functional__ = false
/* styles */
var textarea___vue_styles__ = null
/* scopeId */
var textarea___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var textarea___vue_module_identifier__ = null
var textarea_Component = textarea_normalizeComponent(
  elements_textarea,
  components_elements_textarea,
  textarea___vue_template_functional__,
  textarea___vue_styles__,
  textarea___vue_scopeId__,
  textarea___vue_module_identifier__
)

/* harmony default export */ var src_components_elements_textarea = (textarea_Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-multiselect/dist/vue-multiselect.min.js
var vue_multiselect_min = __webpack_require__("RUzx");
var vue_multiselect_min_default = /*#__PURE__*/__webpack_require__.n(vue_multiselect_min);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/elements/address.vue

//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var elements_address = ({
  props: ['value', 'field', 'currentLanguage', 'disabledStatus', 'countries'],
  components: {
    Multiselect: vue_multiselect_min_default.a
  },
  data: function data() {
    return {
      val: this.value,
      countrylist: []
    };
  },

  methods: {
    countrySelected: function countrySelected(e) {
      this.val.country = e;
      this.$emit('input', this.val);
      this.$emit('change', '');
    },
    dataChanged: function dataChanged() {
      this.$emit('input', this.val);
      this.$emit('change', '');
    }
  },
  created: function created() {
    var _this = this;

    keys_default()(this.countries).forEach(function (country) {
      _this.countrylist.push({
        countrycode: country,
        country: _this.countries[country][_this.currentLanguage]
      });
    });
    if (this.val.country.length > 3) {
      this.val.country = this.countrylist.filter(function (country) {
        return country.country === _this.val.country;
      })[0];
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-be25c144","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/address.vue
var address_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('label',{attrs:{"for":_vm.field.id}},[_vm._v(_vm._s(_vm.field.label[_vm.currentLanguage])+" "),(_vm.field.required)?_c('span',{staticClass:"required"},[_vm._v("*")]):_vm._e()]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.val.street),expression:"val.street"}],staticClass:"street",attrs:{"name":_vm.field.name + 'street',"placeholder":_vm.field.placeholders.street[_vm.currentLanguage],"type":"text","readonly":_vm.field.readonly,"disabled":_vm.disabledStatus(_vm.field.disabled),"multiple":_vm.field.multi,"required":_vm.field.required},domProps:{"value":(_vm.val.street)},on:{"change":_vm.dataChanged,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.val, "street", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.val.number),expression:"val.number"}],staticClass:"number",attrs:{"name":_vm.field.name + 'number',"placeholder":_vm.field.placeholders.number[_vm.currentLanguage],"type":"number","readonly":_vm.field.readonly,"disabled":_vm.disabledStatus(_vm.field.disabled),"multiple":_vm.field.multi,"required":_vm.field.required},domProps:{"value":(_vm.val.number)},on:{"change":_vm.dataChanged,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.val, "number", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.val.zipcode),expression:"val.zipcode"}],staticClass:"zipcode",attrs:{"name":_vm.field.name + 'zipcode',"placeholder":_vm.field.placeholders.zipcode[_vm.currentLanguage],"type":"text","readonly":_vm.field.readonly,"disabled":_vm.disabledStatus(_vm.field.disabled),"multiple":_vm.field.multi,"required":_vm.field.required},domProps:{"value":(_vm.val.zipcode)},on:{"change":_vm.dataChanged,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.val, "zipcode", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.val.residence),expression:"val.residence"}],staticClass:"residence",attrs:{"name":_vm.field.name + 'residence',"placeholder":_vm.field.placeholders.residence[_vm.currentLanguage],"type":"text","readonly":_vm.field.readonly,"disabled":_vm.disabledStatus(_vm.field.disabled),"multiple":_vm.field.multi,"required":_vm.field.required},domProps:{"value":(_vm.val.residence)},on:{"change":_vm.dataChanged,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.val, "residence", $event.target.value)}}}),_vm._v(" "),(_vm.countrylist.length > 0)?_c('multiselect',{attrs:{"name":_vm.field.name + 'country',"track-by":"countrycode","label":"country","value":_vm.val.country,"options":_vm.countrylist,"placeholder":_vm.field.placeholders.country[_vm.currentLanguage]},on:{"input":_vm.countrySelected}}):_vm._e(),_vm._v(" "),(_vm.field.description[_vm.currentLanguage])?_c('p',{staticClass:"small"},[_vm._v(_vm._s(_vm.field.description[_vm.currentLanguage]))]):_vm._e()],1)}
var address_staticRenderFns = []
var address_esExports = { render: address_render, staticRenderFns: address_staticRenderFns }
/* harmony default export */ var components_elements_address = (address_esExports);
// CONCATENATED MODULE: ./src/components/elements/address.vue
function injectStyle (ssrContext) {
  __webpack_require__("mPLW")
}
var address_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var address___vue_template_functional__ = false
/* styles */
var address___vue_styles__ = injectStyle
/* scopeId */
var address___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var address___vue_module_identifier__ = null
var address_Component = address_normalizeComponent(
  elements_address,
  components_elements_address,
  address___vue_template_functional__,
  address___vue_styles__,
  address___vue_scopeId__,
  address___vue_module_identifier__
)

/* harmony default export */ var src_components_elements_address = (address_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/elements/step.vue
//
//
//
//
//
//
//

/* harmony default export */ var step = ({
  props: ['value', 'field', 'currentLanguage', 'disabledStatus']
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b0ec2880","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/step.vue
var step_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',{attrs:{"id":_vm.field.id}},[_vm._v(_vm._s(_vm.field.label[_vm.currentLanguage]))]),_vm._v(" "),(_vm.field.description[_vm.currentLanguage])?_c('p',{staticClass:"small",domProps:{"innerHTML":_vm._s(_vm.field.description[_vm.currentLanguage])}}):_vm._e()])}
var step_staticRenderFns = []
var step_esExports = { render: step_render, staticRenderFns: step_staticRenderFns }
/* harmony default export */ var elements_step = (step_esExports);
// CONCATENATED MODULE: ./src/components/elements/step.vue
var step_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var step___vue_template_functional__ = false
/* styles */
var step___vue_styles__ = null
/* scopeId */
var step___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var step___vue_module_identifier__ = null
var step_Component = step_normalizeComponent(
  step,
  elements_step,
  step___vue_template_functional__,
  step___vue_styles__,
  step___vue_scopeId__,
  step___vue_module_identifier__
)

/* harmony default export */ var components_elements_step = (step_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/elements/description.vue
//
//
//
//
//
//
//

/* harmony default export */ var description = ({
  props: ['value', 'field', 'currentLanguage', 'disabledStatus']
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2959e23e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/description.vue
var description_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',{attrs:{"id":_vm.field.id}},[_vm._v(_vm._s(_vm.field.label[_vm.currentLanguage]))]),_vm._v(" "),(_vm.field.description[_vm.currentLanguage])?_c('p',{staticClass:"small",domProps:{"innerHTML":_vm._s(_vm.field.description[_vm.currentLanguage])}}):_vm._e()])}
var description_staticRenderFns = []
var description_esExports = { render: description_render, staticRenderFns: description_staticRenderFns }
/* harmony default export */ var elements_description = (description_esExports);
// CONCATENATED MODULE: ./src/components/elements/description.vue
var description_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var description___vue_template_functional__ = false
/* styles */
var description___vue_styles__ = null
/* scopeId */
var description___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var description___vue_module_identifier__ = null
var description_Component = description_normalizeComponent(
  description,
  elements_description,
  description___vue_template_functional__,
  description___vue_styles__,
  description___vue_scopeId__,
  description___vue_module_identifier__
)

/* harmony default export */ var components_elements_description = (description_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/elements/file.vue
//
//
//
//
//
//
//
//
//

/* harmony default export */ var elements_file = ({
  props: ['value', 'field', 'currentLanguage', 'disabledStatus', 'files', 'fieldIndex', 'removeFile']
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f492041e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/file.vue
var file_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('label',{attrs:{"for":_vm.field.id}},[_vm._v(_vm._s(_vm.field.label[_vm.currentLanguage])+" "),(_vm.field.required)?_c('span',{staticClass:"required"},[_vm._v("*")]):_vm._e()]),_vm._v(" "),_c('input',{attrs:{"name":_vm.field.name,"type":_vm.field.subtype,"id":_vm.field.id,"readonly":_vm.field.readonly,"disabled":_vm.disabledStatus(_vm.field.disabled),"multiple":_vm.field.multi,"required":_vm.field.required},domProps:{"value":_vm.value},on:{"change":function($event){_vm.$emit('input', $event);_vm.$emit('change', '')}}}),_vm._v(" "),_vm._l((_vm.files),function(file,index){return _c('span',{key:index,staticClass:"file"},[_vm._v(_vm._s(file.name)),_c('span',{staticClass:"remove",on:{"click":function($event){_vm.removeFile(_vm.fieldIndex, index)}}},[_vm._v("✖")])])}),_vm._v(" "),(_vm.field.description[_vm.currentLanguage])?_c('p',{staticClass:"small",domProps:{"innerHTML":_vm._s(_vm.field.description[_vm.currentLanguage])}}):_vm._e()],2)}
var file_staticRenderFns = []
var file_esExports = { render: file_render, staticRenderFns: file_staticRenderFns }
/* harmony default export */ var components_elements_file = (file_esExports);
// CONCATENATED MODULE: ./src/components/elements/file.vue
function file_injectStyle (ssrContext) {
  __webpack_require__("RfYK")
}
var file_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var file___vue_template_functional__ = false
/* styles */
var file___vue_styles__ = file_injectStyle
/* scopeId */
var file___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var file___vue_module_identifier__ = null
var file_Component = file_normalizeComponent(
  elements_file,
  components_elements_file,
  file___vue_template_functional__,
  file___vue_styles__,
  file___vue_scopeId__,
  file___vue_module_identifier__
)

/* harmony default export */ var src_components_elements_file = (file_Component.exports);

// EXTERNAL MODULE: ./node_modules/@finpo/vue2-recaptcha-invisible/dist/index.js
var dist = __webpack_require__("OqAv");
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













/* harmony default export */ var App = ({
  name: 'FormRender',
  components: {
    'c-select': src_components_elements_select,
    'c-radio': src_components_elements_radio,
    'c-input': components_elements_input,
    'c-checkbox': src_components_elements_checkbox,
    'c-optin': src_components_elements_optin,
    'c-textarea': src_components_elements_textarea,
    'c-address': src_components_elements_address,
    'c-step': components_elements_step,
    'c-description': components_elements_description,
    'c-file': src_components_elements_file,
    'gRecaptcha': dist_default.a
  },
  data: function data() {
    return {
      steps: {
        current: 1
      },
      mode: 'render',
      uploading: false,
      multistep: 0,
      id: window.$id,
      authenticated: window.$authenticated,
      userdata: window.$data,
      currentLanguage: window.$language,
      entryLimitReached: false,
      stepFields: [],
      item: {},
      data: [],
      errors: [],
      countries: {},
      sending: {
        progress: false,
        done: false,
        error: false
      },
      dataToSend: {}
    };
  },

  methods: {
    nextAvailableStep: function nextAvailableStep(current) {
      var _this = this;

      var allSteps = this.item.fields.filter(function (field) {
        return field.type === 'step' && field.step > current;
      });
      var next = this.multistep + 1;
      allSteps.some(function (field) {
        if (_this.checkDependsOn(field)) {
          next = field.step;
          return true;
        }
      });
      return next;
    },
    prevAvailableStep: function prevAvailableStep(current) {
      var _this2 = this;

      var allSteps = this.item.fields.filter(function (field) {
        return field.type === 'step' && field.step < current;
      });
      var prev = 0;
      allSteps.forEach(function (field) {
        if (_this2.checkDependsOn(field)) {
          prev = field.step;
        }
      });
      return prev;
    },
    prevStep: function prevStep() {
      this.steps.current = this.prevAvailableStep(this.steps.current);
    },
    nextStep: function nextStep() {
      var checkForm = this.validateForm(false);
      if (checkForm) {
        this.steps.current = this.nextAvailableStep(this.steps.current);
      }
    },
    disabledStatus: function disabledStatus(state) {
      return this.mode === 'builder' ? true : state;
    },
    checkDependsOn: function checkDependsOn(field) {
      var _this3 = this;

      var notMatched = false;
      if (field.dependson.length > 0) {
        field.dependson.forEach(function (dependency) {
          var dependencyField = _this3.item.fields.filter(function (depField) {
            return depField.id === dependency.field;
          })[0];
          if (dependency.value === 'filled') {
            if (dependencyField.value.length < 1) {
              notMatched = true;
            }
          } else if (dependency.value === 'empty') {
            if (dependencyField.value.length > 0) {
              notMatched = true;
            }
          } else {
            if (dependencyField.value instanceof Array) {
              if (dependencyField.value.indexOf(dependency.value) < 0) {
                notMatched = true;
              }
            } else {
              if (dependencyField.value !== dependency.value) {
                notMatched = true;
              }
            }
          }
        });
      }
      return !notMatched;
    },
    clearError: function clearError(index) {
      if (this.errors.indexOf(index) > -1) {
        this.errors.splice(this.errors.indexOf(index), 1);
      }
    },
    multiCheck: function multiCheck(e, index) {
      if (this.item.fields[index].value.indexOf(e) > -1) {
        this.item.fields[index].value.splice(this.item.fields[index].value.indexOf(e), 1);
      } else {
        this.item.fields[index].value.push(e);
      }
    },
    inputChanged: function inputChanged(e, index) {
      var _this4 = this;

      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) {
        return false;
      }
      if (!(this.item.fields[index].value instanceof Array)) {
        this.item.fields[index].value = [];
      }
      keys_default()(files).forEach(function (key) {
        var file = files[key];
        _this4.uploading = true;
        var reader = new FileReader();
        reader.onload = function (event) {
          _this4.$nextTick(function () {
            if (!(_this4.item.attachments instanceof Object)) {
              var tempObj = {};
              tempObj.attachments = {};
              _this4.item = assign_default()({}, _this4.item, tempObj);
            }
            if (!(_this4.item.attachments[index] instanceof Array)) {
              var _tempObj = {};
              _tempObj[index] = [];
              _this4.item.attachments = assign_default()({}, _this4.item.attachments, _tempObj);
            }
            _this4.item.attachments[index].push({
              type: file.type,
              name: file.name,
              content: event.target.result.split(',')[1]
            });
            _this4.uploading = false;
          });
        };
        reader.readAsDataURL(file);
      });
    },
    removeFile: function removeFile(field, file) {
      this.item.attachments[field].splice(file, 1);
    },
    validateForm: function validateForm(normalSubmit) {
      var _this5 = this;

      this.data = [];
      var form = JSON.parse(stringify_default()(this.item));
      var senderAddress = '';
      var optin = {};
      form.fields.forEach(function (field, index) {
        if (field.type === 'description') {
          return;
        }
        if (!normalSubmit) {
          if (field.required) {
            if (_this5.multistep > 0) {
              if (field.belongsToStep === _this5.steps.current) {
                if (!field.value || field.value && field.value.length === 0) {
                  if (_this5.checkDependsOn(_this5.stepFields[field.belongsToStep - 1]) && _this5.checkDependsOn(field)) {
                    _this5.errors.push(index);
                  }
                }
              }
            } else {
              if (!field.value || field.value && field.value.length === 0) {
                _this5.errors.push(index);
              }
            }
          }
        } else {
          if (field.required && field.value && field.value.length === 0) {
            if (_this5.multistep > 0 && field.belongsToStep > 0) {
              if (_this5.checkDependsOn(_this5.stepFields[field.belongsToStep - 1]) && _this5.checkDependsOn(field)) {
                _this5.errors.push(index);
              }
            } else {
              _this5.errors.push(index);
            }
          } else if (field.required && !field.value) {
            if (_this5.multistep > 0 && field.belongsToStep > 0) {
              if (_this5.checkDependsOn(_this5.stepFields[field.belongsToStep - 1]) && _this5.checkDependsOn(field)) {
                _this5.errors.push(index);
              }
            } else {
              _this5.errors.push(index);
            }
          }
        }

        if (_this5.item.mail.sender.copy && _this5.item.mail.sender.field.length > 2 && field.id === _this5.item.mail.sender.field) {
          senderAddress = field.value;
        }
        if (field.subtype === 'optin') {
          optin = field;
        }
        var value = field.value;
        if (field.options && field.options.length > 0) {
          value = field.options.filter(function (option) {
            if (field.value instanceof Array) {
              return field.value.indexOf(option.value) > -1;
            } else {
              return option.value === field.value;
            }
          });
          value.forEach(function (val, index) {
            value[index] = value[index].label;
          });
        }
        if (field.subtype === 'file') {
          value = form.attachments[index];
        }
        if (field.type === 'address') {
          if (!normalSubmit) {
            if (_this5.multistep > 0 && field.belongsToStep > 0) {
              if (field.belongsToStep === _this5.steps.current) {
                if (_this5.checkDependsOn(_this5.stepFields[field.belongsToStep - 1]) && _this5.checkDependsOn(field)) {
                  if (!(_this5.countries[value.country.countrycode] instanceof Object) && field.required) {
                    _this5.errors.push(index);
                  } else {
                    value.country = _this5.countries[value.country.countrycode];
                  }
                }
              }
            } else {
              if (!(_this5.countries[value.country.countrycode] instanceof Object) && field.required) {
                _this5.errors.push(index);
              } else {
                value.country = _this5.countries[value.country.countrycode];
              }
            }
          } else {
            if (_this5.multistep > 0 && field.belongsToStep > 0) {
              if (_this5.checkDependsOn(_this5.stepFields[field.belongsToStep - 1]) && _this5.checkDependsOn(field)) {
                if (!(_this5.countries[value.country.countrycode] instanceof Object) && field.required) {
                  _this5.errors.push(index);
                } else {
                  value.country = _this5.countries[value.country.countrycode];
                }
              }
            } else {
              if (!(_this5.countries[value.country.countrycode] instanceof Object) && field.required) {
                _this5.errors.push(index);
              } else {
                value.country = _this5.countries[value.country.countrycode];
              }
            }
          }
        }
        if (_this5.multistep > 0) {
          if (field.belongsToStep && field.belongsToStep === 1) {
            if (_this5.checkDependsOn(field)) {
              _this5.data.push({
                name: field.name,
                label: field.label,
                value: value,
                dbField: field.dbField
              });
            }
          } else {
            if (field.belongsToStep && _this5.checkDependsOn(_this5.stepFields[field.belongsToStep - 1]) && _this5.checkDependsOn(field)) {
              _this5.data.push({
                name: field.name,
                label: field.label,
                value: value,
                dbField: field.dbField
              });
            }
          }
        } else {
          _this5.data.push({
            name: field.name,
            label: field.label,
            value: value,
            dbField: field.dbField
          });
        }
      });

      var allEmail = this.item.fields.filter(function (field) {
        return field.subtype === 'email';
      });
      if (this.multistep > 0 && senderAddress.length < 3 && allEmail.length > 0 && this.item.mail.sender.field.length < 1) {
        allEmail.forEach(function (field, index) {
          if (_this5.item.mail.sender.copy && field.subtype === 'email' && field.value && field.value.length > 8) {
            senderAddress = field.value;
          }
        });
      }

      if (this.errors.length === 0) {
        this.dataToSend = {
          data: this.data,
          attachments: this.item.attachments,
          language: this.currentLanguage,
          mail: this.item.mail,
          name: this.item.name,
          sender: senderAddress,
          optin: optin
        };
        if (normalSubmit) {
          this.sendForm();
        }
        return true;
      } else {
        return false;
      }
    },
    submitForm: function submitForm(token) {
      var _this6 = this;

      if (typeof token === 'string' || token instanceof String) {
        this.axios.put('/api/v2/Forms/recaptcha/' + this.id, {
          token: token
        }).then(function (response) {
          if (response.data.success) {
            _this6.sendForm();
          }
        }).catch(function (error) {
          console.error(error);
        });
      }
    },
    sendForm: function sendForm() {
      var _this7 = this;

      this.$Progress.start();
      this.axios.put('/api/v2/Forms/submitForm/' + this.id, this.dataToSend).then(function (response) {
        _this7.dataToSend = {};
        if (response.data.error || response.data.errors) {
          _this7.sending.error = true;
          _this7.$Progress.fail();
        } else {
          if (response.data.result.system[0].status === 'rejected' || response.data.result.system[0].status === 'invalid') {
            _this7.sending.error = true;
          }
          if (_this7.item.mail.sender.copy) {
            if (response.data.result.copy[0].status === 'rejected' || response.data.result.copy[0].status === 'invalid') {
              _this7.sending.error = true;
            }
          }
          _this7.sending.progress = false;
          _this7.sending.done = true;
          if (_this7.sending.error) {
            _this7.$Progress.fail();
          } else {
            _this7.$Progress.finish();
          }
        }
      }).catch(function (error) {
        _this7.dataToSend = {};
        _this7.sending.progress = false;
        _this7.sending.done = true;
        _this7.sending.error = true;
        console.error(error);
        _this7.$Progress.fail();
      });
    }
  },
  created: function created() {
    var _this8 = this;

    if (this.authenticated) {
      this.userdata = JSON.parse(this.userdata);
    }
    this.$Progress.start();
    this.axios.get('/api/v2/Forms/getRenderForm/' + this.id).then(function (response) {
      _this8.item = assign_default()({}, response.data, { attachments: {} });
      var emailField = {};
      _this8.item.fields.forEach(function (field, index) {
        if (field.subtype === 'checkbox' && field.multi) {
          _this8.item.fields[index].value = [];
        }
        if (field.subtype === 'email') {
          emailField = field;
        }
        if (field.type === 'step') {
          _this8.multistep++;
          _this8.item.fields[index].step = _this8.multistep;
          _this8.stepFields[_this8.multistep - 1] = field;
        } else {
          _this8.item.fields[index].belongsToStep = _this8.multistep;
        }
        if (typeof_default()(field.autofill) === 'object' && field.autofill !== null) {
          if (field.type === 'step') {
            return;
          }
          if (field.type === 'address') {
            try {
              _this8.item.fields[index].value = {
                street: _this8.userdata[field.autofill.street.plugin][field.autofill.street.field],
                number: _this8.userdata[field.autofill.number.plugin][field.autofill.number.field],
                zipcode: _this8.userdata[field.autofill.zipcode.plugin][field.autofill.zipcode.field],
                residence: _this8.userdata[field.autofill.residence.plugin][field.autofill.residence.field],
                country: _this8.userdata[field.autofill.country.plugin][field.autofill.country.field]
              };
            } catch (err) {}
          } else if (!Array.isArray(field.autofill)) {
            try {
              _this8.item.fields[index].value = _this8.userdata[field.autofill.plugin][field.autofill.field];
            } catch (err) {}
          }
        }
      });
      if (_this8.item.reviews && _this8.item.reviews.enabled) {
        if (_this8.item.reviews.limit === 1) {
          var currentuser = keys_default()(_this8.userdata);
          if (currentuser.length > 0) {
            currentuser = currentuser[0];
            var user = _this8.userdata[currentuser];
            if (user.length > 0) {
              user = user['email'];
            }
            var entries = _this8.item.data.filter(function (obj) {
              return obj[emailField.label.nl] === user;
            });
            if (entries.length > 0 && !_this8.item.reviews.canEdit) {
              _this8.entryLimitReached = true;
            } else if (entries.length > 0 && _this8.item.reviews.canEdit) {
              _this8.entryLimitReached = true; // nog aanpassen voor bewerken eerder ingevulde beoordeling
            }
          }
        }
      }
      var hasSendToField = _this8.item.fields.filter(function (field) {
        return field.id === _this8.item.mail.sender.field;
      });
      var originalSendCopy = _this8.item.mail.sender.copy;
      if (_this8.item.mail.sender.copy && !hasSendToField.length > 0) {
        _this8.item.mail.sender.copy = false;
      }
      var emailFields = _this8.item.fields.filter(function (field) {
        return field.subtype === 'email';
      });
      if (originalSendCopy && _this8.multistep > 0 && emailFields.length > 1) {
        _this8.item.mail.sender.copy = true;
      }

      _this8.item.mail.messages.success[_this8.currentLanguage] = _this8.item.mail.messages.success[_this8.currentLanguage] || _this8.item.mail.messages.success.nl || 'success';
      _this8.item.mail.messages.error[_this8.currentLanguage] = _this8.item.mail.messages.error[_this8.currentLanguage] || _this8.item.mail.messages.error.nl || 'error';
      _this8.item.mail.messages.send[_this8.currentLanguage] = _this8.item.mail.messages.send[_this8.currentLanguage] || _this8.item.mail.messages.send.nl || 'send';
      if (_this8.item.mail.type === 'smtp') {
        if (!_this8.item.mail.smtp.server || !_this8.item.mail.smtp.port) {
          _this8.item.mail.type = 'mailchimp';
        }
      }
      var address = _this8.item.fields.filter(function (field) {
        return field.type === 'address';
      });
      _this8.$Progress.finish();
      if (address.length > 0) {
        _this8.$Progress.start();
        _this8.axios.get('/countries/' + _this8.currentLanguage + '/country.json').then(function (response) {
          _this8.countries = response.data;
          keys_default()(response.data).forEach(function (country) {
            var tempObj = {};
            tempObj['nl'] = response.data[country];
            _this8.countries[country] = assign_default()({}, tempObj);
          });
          _this8.$Progress.finish();
        }).catch(function (error) {
          console.error(error);
          _this8.$Progress.fail();
        });
      }
    }).catch(function (error) {
      console.error(error);
      _this8.$Progress.fail();
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-65975ec5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vue-progress-bar'),_vm._v(" "),(!_vm.entryLimitReached)?_c('form',{on:{"submit":function($event){$event.preventDefault();_vm.submitForm($event)}}},[(Object.keys(_vm.item).length > 0 && _vm.item.mail.from.length > 8 && _vm.item.mail.to.length > 8 && !_vm.sending.done)?_c('div',[_vm._l((_vm.item.fields),function(formField,index){return (_vm.checkDependsOn(formField))?[_c('section',{directives:[{name:"show",rawName:"v-show",value:(formField.belongsToStep == 0 || formField.belongsToStep == _vm.steps.current || _vm.multistep == 0),expression:"formField.belongsToStep == 0 || formField.belongsToStep == steps.current || multistep == 0"}]},[(formField.type == 'input' && formField.subtype != 'checkbox' && formField.subtype != 'radio' && formField.subtype != 'file' && formField.subtype != 'optin')?[_c('c-input',{key:formField.id,class:{ 'error': _vm.errors.indexOf(index) > -1 },attrs:{"field":formField,"currentLanguage":_vm.currentLanguage,"disabled-status":_vm.disabledStatus},on:{"change":function($event){_vm.clearError(index)}},model:{value:(formField.value),callback:function ($$v) {_vm.$set(formField, "value", $$v)},expression:"formField.value"}})]:_vm._e(),_vm._v(" "),(formField.subtype == 'file')?[_c('c-file',{key:formField.id,class:{ 'error': _vm.errors.indexOf(index) > -1 },attrs:{"field":formField,"currentLanguage":_vm.currentLanguage,"disabled-status":_vm.disabledStatus,"field-index":index,"remove-file":_vm.removeFile,"files":_vm.item.attachments[index]},on:{"input":function($event){_vm.inputChanged($event, index)},"change":function($event){_vm.clearError(index)}},model:{value:(formField.value),callback:function ($$v) {_vm.$set(formField, "value", $$v)},expression:"formField.value"}})]:_vm._e(),_vm._v(" "),(formField.type == 'input' && formField.subtype == 'checkbox')?[_c('c-checkbox',{key:formField.id,class:{ 'error': _vm.errors.indexOf(index) > -1 },attrs:{"multi-check":_vm.multiCheck,"field-index":index,"field":formField,"currentLanguage":_vm.currentLanguage,"disabled-status":_vm.disabledStatus},on:{"input":function($event){_vm.clearError(index)}},model:{value:(formField.value),callback:function ($$v) {_vm.$set(formField, "value", $$v)},expression:"formField.value"}})]:_vm._e(),_vm._v(" "),(formField.type == 'input' && formField.subtype == 'optin')?[_c('c-optin',{key:formField.id,class:{ 'error': _vm.errors.indexOf(index) > -1 },attrs:{"field-index":index,"field":formField,"currentLanguage":_vm.currentLanguage,"disabled-status":_vm.disabledStatus},on:{"input":function($event){_vm.clearError(index)}},model:{value:(formField.value),callback:function ($$v) {_vm.$set(formField, "value", $$v)},expression:"formField.value"}})]:_vm._e(),_vm._v(" "),(formField.type == 'input' && formField.subtype == 'radio')?[_c('c-radio',{key:formField.id,class:{ 'error': _vm.errors.indexOf(index) > -1 },attrs:{"field":formField,"currentLanguage":_vm.currentLanguage,"disabled-status":_vm.disabledStatus},on:{"change":function($event){_vm.clearError(index)}},model:{value:(formField.value),callback:function ($$v) {_vm.$set(formField, "value", $$v)},expression:"formField.value"}})]:_vm._e(),_vm._v(" "),(formField.type == 'textarea')?[_c('c-textarea',{key:formField.id,class:{ 'error': _vm.errors.indexOf(index) > -1 },attrs:{"field":formField,"currentLanguage":_vm.currentLanguage,"disabled-status":_vm.disabledStatus},on:{"change":function($event){_vm.clearError(index)}},model:{value:(formField.value),callback:function ($$v) {_vm.$set(formField, "value", $$v)},expression:"formField.value"}})]:_vm._e(),_vm._v(" "),(formField.type == 'select')?[_c('c-select',{key:formField.id,class:{ 'error': _vm.errors.indexOf(index) > -1 },attrs:{"field":formField,"currentLanguage":_vm.currentLanguage,"disabled-status":_vm.disabledStatus},on:{"change":function($event){_vm.clearError(index)}},model:{value:(formField.value),callback:function ($$v) {_vm.$set(formField, "value", $$v)},expression:"formField.value"}},[(formField.defaultSelectText[_vm.currentLanguage])?_c('option',{attrs:{"value":"","selected":"","disabled":""}},[_vm._v(_vm._s(formField.defaultSelectText[_vm.currentLanguage]))]):_vm._e()])]:_vm._e(),_vm._v(" "),(formField.type == 'address')?[(Object.keys(_vm.countries).length > 0)?_c('c-address',{key:formField.id,class:{ 'error': _vm.errors.indexOf(index) > -1 },attrs:{"countries":_vm.countries,"field":formField,"currentLanguage":_vm.currentLanguage,"disabled-status":_vm.disabledStatus},on:{"change":function($event){_vm.clearError(index)}},model:{value:(formField.value),callback:function ($$v) {_vm.$set(formField, "value", $$v)},expression:"formField.value"}}):_vm._e()]:_vm._e(),_vm._v(" "),(formField.type == 'description')?[_c('c-description',{key:formField.id,attrs:{"field":formField,"currentLanguage":_vm.currentLanguage}})]:_vm._e()],2),_vm._v(" "),(formField.type == 'step')?[_c('section',{directives:[{name:"show",rawName:"v-show",value:(formField.step == _vm.steps.current),expression:"formField.step == steps.current"}]},[_c('c-step',{key:formField.id,attrs:{"field":formField,"currentLanguage":_vm.currentLanguage}})],1)]:_vm._e()]:_vm._e()}),_vm._v(" "),_c('div',[(_vm.item.recaptcha.sitekey.length > 0 && (!_vm.multistep || _vm.steps.current == _vm.multistep || _vm.nextAvailableStep(_vm.steps.current) > _vm.multistep))?[_c('g-recaptcha',{attrs:{"data-sitekey":_vm.item.recaptcha.sitekey,"data-validate":_vm.validateForm,"data-callback":_vm.submitForm,"data-badge":"inline","data-btn-class":"right","data-btn-disabled":_vm.uploading || _vm.errors.length > 0 || _vm.sending.progress,"disabled":_vm.uploading || _vm.errors.length > 0 || _vm.sending.progress}},[_vm._v(_vm._s(_vm.item.mail.messages.send[_vm.currentLanguage])+"\n          ")])]:_vm._e(),_vm._v(" "),(_vm.item.recaptcha.sitekey.length < 1 && (!_vm.multistep || _vm.steps.current == _vm.multistep || _vm.nextAvailableStep(_vm.steps.current) > _vm.multistep))?[_c('button',{staticClass:"right",attrs:{"type":"submit","disabled":_vm.uploading || _vm.errors.length > 0 || _vm.sending.progress},on:{"click":function($event){$event.preventDefault();_vm.validateForm(true)}}},[_vm._v(_vm._s(_vm.item.mail.messages.send[_vm.currentLanguage]))])]:_vm._e(),_vm._v(" "),_c('section',{directives:[{name:"show",rawName:"v-show",value:(_vm.multistep && _vm.prevAvailableStep(_vm.steps.current) > 0),expression:"multistep && prevAvailableStep(steps.current) > 0"}],staticStyle:{"display":"inline"}},[_c('button',{attrs:{"type":"submit","disabled":_vm.uploading || _vm.errors.length > 0 || _vm.sending.progress},on:{"click":function($event){$event.preventDefault();_vm.prevStep($event)}}},[_vm._v("Vorige")])]),_vm._v(" "),_c('section',{directives:[{name:"show",rawName:"v-show",value:(_vm.multistep && _vm.nextAvailableStep(_vm.steps.current) <= _vm.multistep),expression:"multistep && nextAvailableStep(steps.current) <= multistep"}],staticStyle:{"display":"inline"}},[_c('button',{staticClass:"right",attrs:{"type":"submit","disabled":_vm.uploading || _vm.errors.length > 0 || _vm.sending.progress},on:{"click":function($event){$event.preventDefault();_vm.nextStep($event)}}},[_vm._v("Volgende")])])],2)],2):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.sending.done && !_vm.sending.error)?_c('div',[_c('p',[_vm._v(_vm._s(_vm.item.mail.messages.success[_vm.currentLanguage]))])]):_vm._e(),_vm._v(" "),(_vm.sending.done && _vm.sending.error)?_c('div',[_c('p',[_vm._v(_vm._s(_vm.item.mail.messages.error[_vm.currentLanguage]))])]):_vm._e(),_vm._v(" "),(_vm.entryLimitReached)?_c('div',[_c('p',[_vm._v("U heeft al een beoordeling geplaatst.")])]):_vm._e()],1)}
var App_staticRenderFns = []
var App_esExports = { render: App_render, staticRenderFns: App_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (App_esExports);
// CONCATENATED MODULE: ./src/App.vue
function App_injectStyle (ssrContext) {
  __webpack_require__("Z+nb")
}
var App_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var App___vue_template_functional__ = false
/* styles */
var App___vue_styles__ = App_injectStyle
/* scopeId */
var App___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var App___vue_module_identifier__ = null
var App_Component = App_normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  App___vue_template_functional__,
  App___vue_styles__,
  App___vue_scopeId__,
  App___vue_module_identifier__
)

/* harmony default export */ var src_App = (App_Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-resource/dist/vue-resource.esm.js
var vue_resource_esm = __webpack_require__("8+8L");

// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__("mtWM");
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);

// EXTERNAL MODULE: ./node_modules/vue-axios/dist/vue-axios.min.js
var vue_axios_min = __webpack_require__("Rf8U");
var vue_axios_min_default = /*#__PURE__*/__webpack_require__.n(vue_axios_min);

// EXTERNAL MODULE: ./node_modules/vue-progressbar/dist/vue-progressbar.js
var vue_progressbar = __webpack_require__("zYko");
var vue_progressbar_default = /*#__PURE__*/__webpack_require__.n(vue_progressbar);

// CONCATENATED MODULE: ./src/main.js







vue_runtime_esm["a" /* default */].use(vue_resource_esm["a" /* default */]);
axios_default.a.defaults.headers.common['X-CMS-Request'] = 'forms';
vue_runtime_esm["a" /* default */].use(vue_axios_min_default.a, axios_default.a);
vue_runtime_esm["a" /* default */].use(vue_progressbar_default.a, {
  color: '#1E90FF',
  failedColor: '#D91E18',
  height: '3px'
});

vue_runtime_esm["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new vue_runtime_esm["a" /* default */]({
  el: '#form-render',
  render: function render(h) {
    return h(src_App);
  }
});

/***/ }),

/***/ "RfYK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Z+nb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mPLW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.js